<template>
	<div class="loading-cirle">
		<div class="text-center pa-50">
			<v-progress-circular :size="getSize" :width="getWidth" :color="getColor" indeterminate></v-progress-circular>
			<div class="text-center caption mt-4">{{getText}}</div>
		</div>
	</div>
</template>

<script>
export default {
	name : 'loading',
	props:{
		text : {
			type : String,
			default : "Bilgiler yükleniyor..."
		},
		size : {
			type : String,
			default : "50"
		},
		width : {
			type : String,
			default : "5"
		},
		color : {
			type : String,
			default : "indigo"
		},
	},
	computed : {
		getText(){
			return this.text || "Bilgiler yükleniyor..."
		},
		getSize(){
			return parseInt(this.size) || 50
		},
		getWidth(){
			return parseInt(this.width) || 5
		},
		getColor(){
			return this.color || "indigo"
		},
	}
}
</script>

<style lang="less">
	.loading-cirle{
		padding:30px 0px;
		color : #aaa;
	}
</style>